import { OrganizationUserRoles } from '../enum/OrganizationUserRoles.enum'

export const AccessRoleConstants = {
  OWNER_ONLY: [OrganizationUserRoles.OWNER],
  MEMBER_LEVEL: [OrganizationUserRoles.MEMBER, OrganizationUserRoles.OWNER],
  BILLING_LEVEL: [OrganizationUserRoles.BILLING, OrganizationUserRoles.OWNER],
  ALL: ['ALL'],
}
